import { useEffect, useMemo, useState } from 'react';
import { currentLanguage$, getLanguage } from '../language';
import { apps$ } from '../apps';
import { Co4App, SystemObject } from '../types';

type CurrentApp = Co4App & { disabled: boolean };

export function useCurrentAppGroups(current: SystemObject) {
  const [apps, setApps] = useState<Array<Co4App>>([]);

  useEffect(() => {
    const sub = apps$.subscribe((apps) => {
      setApps(apps);
    });

    return () => sub.unsubscribe();
  }, []);

  return useMemo(() => {
    const enabledApps: Array<CurrentApp> = [];
    const disabledApps: Array<CurrentApp> = [];

    for (const app of apps) {
      if (!app.options.requires(current)) {
        continue;
      }

      if (app.options.handles(current)) {
        enabledApps.push({ ...app, disabled: false });
      } else {
        disabledApps.push({ ...app, disabled: true });
      }
    }

    return {
      currentApps: [...enabledApps, ...disabledApps],
      disabledApps,
      enabledApps,
    };
  }, [current, apps]);
}

export function useCurrentApps(current: SystemObject) {
  return useCurrentAppGroups(current).currentApps;
}

export function useCurrentLanguage() {
  const [current, setCurrent] = useState(getLanguage);

  useEffect(() => {
    const sub = currentLanguage$.subscribe(setCurrent);
    return () => sub.unsubscribe();
  }, []);

  return current;
}
